module.exports = __webpack_public_path__ + "img/Video.6d196c0d.png";